// // tables/WorkOrderTable.tsx
// import React from 'react';
// import { Card } from '@components/card/card';

// interface WorkOrderTableProps {
//   data: any[];
//   selectedId: string | null;
//   onSelect: (id: string, code: string) => void;
//   isLoading: boolean;
//   language: string;
// }

// export const WorkOrderTable: React.FC<WorkOrderTableProps> = ({ data, selectedId, onSelect, isLoading, language }) => {
//   const isArabic = language === 'ar';

//   // console.log(data);

//   if (isLoading) {
//     return (
//       <div className='text-center py-5'>
//         <div className='spinner-border text-primary' role='status'>
//           <span className='visually-hidden'>جاري التحميل...</span>
//         </div>
//         <p className='text-muted mt-2'>جاري تحميل أوامر الصيانة...</p>
//       </div>
//     );
//   }

//   return (
//     <Card className='mb-4'>
//       <div className='card-header d-flex justify-content-between align-items-center'>
//         <h6 className='mb-0'>
//           <i className='fas fa-wrench me-2'></i>
//           قائمة أوامر الصيانة
//         </h6>
//       </div>

//       <div className='card-body p-0'>
//         <div className='table-responsive'>
//           <table className='table table-hover mb-0'>
//             <thead className='table-light fw-bold'>
//               <tr>
//                 <th className=' small'  >
//                   #
//                 </th>
//                 <th className='text-center small' >
//                   رقم الأمر
//                 </th>
//                 <th className='text-center small'  >
//                   التاريخ
//                 </th>
//                 <th className='text-center small'  >
//                   المعدات
//                 </th>

             
//               </tr>
//             </thead>
//             <tbody>
//               {data.map((item, index) => {
//                 const isSelected = selectedId === item.id;

//                 return (
//                   <tr
//                     key={item.id}
//                     className={isSelected ? 'table-primary' : ''}
//                     style={{ cursor: 'pointer' }}
//                     onClick={() => onSelect(item.id, item.orderCode || item.code)}
//                   >
//                     <td className='text-center align-middle'>
//                       <div className='form-check'>
//                         <input
//                           type='radio'
//                           className='form-check-input'
//                           name='workOrderSelection'
//                           checked={isSelected}
//                           onChange={() => onSelect(item.id, item.orderCode || item.code)}
//                         />
//                       </div>
//                     </td>

//                     <td className='text-center align-middle fw-bold'>{item.orderCode || item.code}</td>

//                     <td className='text-center align-middle'>
//                       {item.startDateSugg ? item.startDateSugg.split('T')[0] : '-'}
//                     </td>

//                     <td className='text-center align-middle'>
//                       {isArabic
//                         ? item.fleetEquipmentsName2 || item.fleetEquipmentsName
//                         : item.fleetEquipmentsName || item.fleetEquipmentsName2}
//                     </td>

             
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <div className='card-footer d-flex justify-content-between align-items-center'>
//         <div className='text-muted small'>
//           عرض {data.length} من {data.length} أمر صيانة
//         </div>
//       </div>
//     </Card>
//   );
// };

// tables/WorkOrderTable.tsx
import React from 'react';
import { Card } from '@components/card/card';
import { useTranslation } from 'react-i18next';

interface WorkOrderTableProps {
  data: any[];
  selectedId: string | null;
  onSelect: (id: string, code: string) => void;
  isLoading: boolean;
  language: string;
}

export const WorkOrderTable: React.FC<WorkOrderTableProps> = ({
  data,
  selectedId,
  onSelect,
  isLoading,
  language
}) => {
  const { t } = useTranslation();
  const isArabic = language === 'ar';

  if (isLoading) {
    return (
      <div className='text-center py-5'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>{t('Loading')}</span>
        </div>
        <p className='text-muted mt-2'>{t('LoadingWorkOrders')}</p>
      </div>
    );
  }

  return (
    <Card className='mb-4'>
      <div className='card-header d-flex justify-content-between align-items-center'>
        <h6 className='mb-0'>
          <i className='fas fa-wrench me-2'></i>
          {t('WorkOrdersListTitle')}
        </h6>
      </div>

      <div className='card-body p-0'>
        <div className='table-responsive'>
          <table className='table table-hover mb-0'>
            <thead className='table-light fw-bold'>
              <tr>
                <th className='small'>
                  #
                </th>
                <th className='text-center small'>
                  {t('OrderNumber')}
                </th>
                <th className='text-center small'>
                  {t('Date')}
                </th>
                <th className='text-center small'>
                  {t('Equipment')}
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map(item => {
                const isSelected = selectedId === item.id;

                return (
                  <tr
                    key={item.id}
                    className={isSelected ? 'table-primary' : ''}
                    style={{ cursor: 'pointer' }}
                    onClick={() => onSelect(item.id, item.orderCode || item.code)}
                  >
                    <td className='text-center align-middle'>
                      <div className='form-check'>
                        <input
                          type='radio'
                          className='form-check-input'
                          name='workOrderSelection'
                          checked={isSelected}
                          onChange={() => onSelect(item.id, item.orderCode || item.code)}
                        />
                      </div>
                    </td>

                    <td className='text-center align-middle fw-bold'>{item.orderCode || item.code}</td>

                    <td className='text-center align-middle'>
                      {item.startDateSugg ? item.startDateSugg.split('T')[0] : '-'}
                    </td>

                    <td className='text-center align-middle'>
                      {isArabic
                        ? item.fleetEquipmentsName2 || item.fleetEquipmentsName
                        : item.fleetEquipmentsName || item.fleetEquipmentsName2}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className='card-footer d-flex justify-content-between align-items-center'>
        <div className='text-muted small'>
          {t('WorkOrdersFooterSummary', {
            count: data.length,
            total: data.length
          })}
        </div>
      </div>
    </Card>
  );
};
